<template>
  <div>
    <b-form-input
      :id="context.id"
      v-model="folio"
      disabled
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: Object
  },
  setup(props, { emit }) {
    const folio = ref('');
    const isDisabled = ref(false);
    onMounted(() => {
      const folioString = props.fieldOptions.fieldTypeCfg.data[0]?.value
      props.context.model = folioString
      isDisabled.value = props.context.attributes.disabled ?? false;
      folio.value = replaceTags(folioString)
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    function replaceTags(str) {
      const now = new Date();

      const replacements = {
        '@DD': String(now.getDate()).padStart(2, '0'),
        '@MM': String(now.getMonth() + 1).padStart(2, '0'),
        '@YYYY': String(now.getFullYear()),
        '@YY': String(now.getFullYear()).substring(2),
        '@HH': String(now.getHours()).padStart(2, '0'),
        '@MIN': String(now.getMinutes()).padStart(2, '0'),
        '@INC': "XX",
        '@INC4': "XXXX",
        '@INC6': "XXXXXX",
      };

      for (const tag in replacements) {
        const value = replacements[tag];
        str = str.replace(new RegExp(tag, 'g'), typeof value === 'function' ? value() : value);
      }

      return str;
    }

    return {
      isDisabled,
      folio,
    }
  }
}
</script>
